import React, { useState } from 'react'
import Header from './Header'
import UserContext from '../../UserContext';
import { url } from "../../utils/url";
import UserProfile from "../../images/avatar-defaul-girls.jpg";
import PlayOption from './PlayOption';
import MainBoard from './MainBoard';
import CountDownTimer from './CountDown';
import { gameStatuses } from '../../pages/FingersBattlePage';

export default function FingersBattleComponent({
  dark,
  handlegameStatus,
  gameStatus
}) {
  let hoursMinSecs = { hours: 0, minutes: 0, seconds: 15 }
  const options = ['rock', 'paper', 'scissors'];
  const [playerWins, setplayeWins] = useState('');
  const [choosenOptions, setchoosenOptions] = useState({
    user: '',
    computer: ''
  })

  const [marks, setmarks] = useState({
    user_score: 0,
    computer_score: 0
  });

  const handleGameEnded = () => {
    handlegameStatus(gameStatuses.ENDED);
  }
  const handleRestartGame = () => {
    handlegameStatus(gameStatuses.PLAYING);
    setmarks({
      user_score: 0,
      computer_score: 0
    })
    setchoosenOptions({
      user: '',
      computer: ''
    })
    setplayeWins('')
  }
  const { user } = React.useContext(
    UserContext
  );

  const handlePlayGame = (myChoice) => {
    let PlayerWin = "";
    const computer_selection = options[Math.floor(Math.random() * 3)];
    setchoosenOptions({ user: myChoice, computer: computer_selection });

    if (myChoice === "rock" && computer_selection === "scissors") {
      PlayerWin = "win";
      setmarks({ ...marks, user_score: marks.user_score + 1 });
    } else if (myChoice === "rock" && computer_selection === "paper") {
      PlayerWin = "lose";
      setmarks({ ...marks, computer_score: marks.computer_score + 1 });
    } else if (myChoice === "scissors" && computer_selection === "paper") {
      PlayerWin = "win";
      setmarks({ ...marks, user_score: marks.user_score + 1 });
    } else if (myChoice === "scissors" && computer_selection === "rock") {
      PlayerWin = "lose";
      setmarks({ ...marks, computer_score: marks.computer_score + 1 });
    } else if (myChoice === "paper" && computer_selection === "rock") {
      PlayerWin = "win";
      setmarks({ ...marks, user_score: marks.user_score + 1 });
    } else if (myChoice === "paper" && computer_selection === "scissors") {
      PlayerWin = "lose";
      setmarks({ ...marks, computer_score: marks.computer_score + 1 });
    } else {
      PlayerWin = "draw";
    }
    setplayeWins(PlayerWin);
  }

  return (
    <>
      <div className="text-center">
        <CountDownTimer gameStatus={gameStatus} hoursMinSecs={hoursMinSecs} handleGameEnded={handleGameEnded} />
      </div>
      <div className="flex md:flex-row lg:flex-row  items-center justify-between phone-flexing">
        <div className="flex  items-center justify-left gap-10 py-3">
          <Header
            names={user?.info?.names}
            username={user?.info?.username}
            imageUrl={user?.info?.profile?.url ? `${url}${user?.info?.profile?.url}` : UserProfile}
          />
          <div className="h-11 w-11 justify-center flex items-center rounded font-bold text-white bg-red-400">{marks.user_score}</div>
        </div>
        <div className="font-bold text-muted">
          VS
        </div>
        <div className="flex  items-center justify-left gap-10 py-3">
          <div className="h-11 w-11 justify-center flex items-center rounded font-bold text-white bg-red-400">{marks.computer_score}</div>
          <Header
            names={'Computer'}
            username={`twika_computer_${18}`}
            imageUrl={UserProfile}
            left={true}
          />
        </div>
      </div>
      <div className="flex gap-2 mt-2 game-option-onphone">
        {gameStatus !== gameStatuses.ENDED &&
          <>
            <PlayOption icon={options[0]} handlePlayGame={handlePlayGame} dark={dark} />
            <PlayOption icon={options[1]} handlePlayGame={handlePlayGame} dark={dark} />
            <PlayOption icon={options[2]} handlePlayGame={handlePlayGame} dark={dark} />
          </>
        }
      </div>
      <div className="">
        <MainBoard
          PlayerWin={playerWins}
          PlayerOption={choosenOptions.user}
          ComputerOption={choosenOptions.computer}
          gameStatus={gameStatus}
          handleRestartGame={handleRestartGame}
          scores={marks}
        />
      </div>
    </>
  )
}
